import { render } from "./StreamManageHighlights.vue?vue&type=template&id=87caa36c&scoped=true"
import script from "./StreamManageHighlights.vue?vue&type=script&lang=js"
export * from "./StreamManageHighlights.vue?vue&type=script&lang=js"

import "./StreamManageHighlights.vue?vue&type=style&index=0&id=87caa36c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87caa36c"],['__file',"src/views/Highlights/StreamManageHighlights.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87caa36c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87caa36c', __exports__)) {
    api.reload('87caa36c', __exports__)
  }
  
  module.hot.accept("./StreamManageHighlights.vue?vue&type=template&id=87caa36c&scoped=true", () => {
    api.rerender('87caa36c', render)
  })

}


export default __exports__